// extracted by mini-css-extract-plugin
export default {"heroEndContainer":"HeroEnd_heroEndContainer__2LdE0"};